import { differenceInMilliseconds } from 'date-fns';
import { useEffect, useState } from 'react';

import { calculateExpiryTimeLeft } from '../helpers/date/date';
import type { DispatchState } from '../interfaces';

export const useExpiredVmTime = (
  expiredTime: string | Date | undefined,
  setOpenExpiredMachineModal: DispatchState<boolean>,
) => {
  const [formattedTime, setFormattedTime] = useState<string>('0m 0s');
  const [millisecondsUntilExpiry, setMillisecondsUntilExpiry] = useState<number>(0);

  // Calculate expires time
  useEffect(() => {
    let interval: NodeJS.Timer;

    if (expiredTime) {
      // On first render, do not show the modal
      if (differenceInMilliseconds(new Date(expiredTime), new Date()) <= 0) {
        setFormattedTime('0m 0s');
      } else {
        interval = setInterval(() => {
          const timeDifference = differenceInMilliseconds(new Date(expiredTime), new Date());
          if (timeDifference <= 0) {
            setOpenExpiredMachineModal(true);
            setFormattedTime('0m 0s');
            clearInterval(interval);
            setMillisecondsUntilExpiry(0);
          } else {
            const { hours, minutes, seconds } = calculateExpiryTimeLeft(new Date(), new Date(expiredTime));
            const hoursString = hours ? `${hours}h` : null;
            const timeFormatted = hoursString
              ? `${hoursString} ${minutes}min ${seconds}s`
              : `${minutes}min ${seconds}s`;
            setFormattedTime(timeFormatted);
            setMillisecondsUntilExpiry(timeDifference);
          }
        }, 1000);
      }
    }
    return () => {
      if (interval) clearInterval(interval);
    };
  }, [expiredTime, setOpenExpiredMachineModal]);

  return { formattedTime, millisecondsUntilExpiry };
};
